import { Person } from '@/models/Person';
import { profileType } from '@/models/Profile';
import { ApplicationState } from '@/store';
import { putPersonRequest, updateMyPersonRequest } from '@/store/person/action';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Dispatch } from 'redux';
import './style.scss';

interface Props {
    handleModalClose?: () => void;
}

const ChangeProfile = ({ handleModalClose }: Props) => {
    const { data: strings } = useSelector((state: ApplicationState) => state.locale);
    const person: Person = useSelector((state: ApplicationState) => state.people.myPerson) as Person;

    const dispatch: Dispatch = useDispatch();
    const history = useHistory();

    const [selectedProfile, setSelectedProfile] = useState<profileType>(person?.dynamicAttributes?.selectedProfile || '');

    const initialProfile = person?.dynamicAttributes?.selectedProfile;

    const handleConfirmProfileSelect = (): void => {
        person.dynamicAttributes = person.dynamicAttributes ? { ...person.dynamicAttributes, selectedProfile } : { selectedProfile };
        dispatch(putPersonRequest({ person, history, willClose: false }));
        history.push('/');
        closeModal();
    };

    const closeModal = () => {
        const htmlElement: HTMLElement | null = document.getElementById('change-modal');
        htmlElement && htmlElement.click();
        handleModalClose && handleModalClose();
    };

    useEffect(() => {
        dispatch(updateMyPersonRequest());
    }, []);

    useEffect(() => {
        if (person) {
            setSelectedProfile(person.dynamicAttributes?.selectedProfile || '');
        }
    }, [person]);

    return (
        <>
            <div className="option-container" onClick={() => setSelectedProfile('HR')} onKeyDown={() => {}} role="button" tabIndex={0}>
                <span className={`${selectedProfile === 'HR' ? 'active' : null}`}>{strings.ACCESS_AS_ADMIN}</span>
                {selectedProfile === 'HR' && <i className="material-icons-outlined align-middle">done</i>}
            </div>
            <div className="option-container" onClick={() => setSelectedProfile('STUDENT')} onKeyDown={() => {}} role="button" tabIndex={0}>
                <span className={`${selectedProfile === 'STUDENT' ? 'active' : null}`}>{strings.ACCESS_AS_USER}</span>
                {selectedProfile === 'STUDENT' && <i className="material-icons-outlined align-middle">done</i>}
            </div>
            <div className="modal-confirm-button">
                <button
                    className="btn btn-secondary confirm-button"
                    data-dismiss="modal"
                    disabled={initialProfile === selectedProfile}
                    onClick={handleConfirmProfileSelect}
                    type="button"
                >
                    {strings.CONFIRM_CHANGES}
                </button>
            </div>
        </>
    );
};

export default ChangeProfile;
